export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: "faq-001",
    question: "海角千万资源原创平台上的内容可以免费使用吗？",
    answer: "平台提供免费和付费两种授权模式。免费素材在标注来源的前提下可用于个人和非商业用途；付费素材提供完整的商业授权，适用于企业品牌传播、广告营销等商业场景。我们建议商业用户选择付费授权，以获得更全面的法律保障。"
  },
  {
    id: "faq-002",
    question: "如何确保平台内容的原创性和版权合规？",
    answer: "我们建立了严格的原创审核机制。所有上传内容均经过AI初筛和人工复审双重校验，确保内容的原创性。同时，我们与多家版权机构合作，建立了完善的版权溯源体系。每位创作者在发布内容时需签署原创声明，确保版权清晰可追溯。"
  },
  {
    id: "faq-003",
    question: "平台支持哪些类型的素材格式？",
    answer: "目前平台支持的素材格式包括：图片类（JPG、PNG、WEBP、PSD、AI）、视频类（MP4、MOV、AVI）、文档类（PDF、PPTX、DOCX）、设计源文件（Figma、Sketch）等。我们持续扩展格式支持范围，以满足创作者多样化的需求。"
  },
  {
    id: "faq-004",
    question: "企业用户如何定制专属资源库？",
    answer: "企业用户可以联系我们的商务团队，开通企业版服务。企业版支持品牌专属素材库搭建、团队协作管理、API接口对接、定制化内容采购等功能。我们会根据企业的具体需求，提供个性化的解决方案。"
  },
  {
    id: "faq-005",
    question: "平台的内容更新频率如何？",
    answer: "平台每日新增超过500件原创内容资源。我们与超过2000位认证创作者保持长期合作，确保资源的持续丰富和更新。同时，平台会根据季节热点和行业趋势，定期推出主题内容专辑，帮助创作者紧跟潮流。"
  },
  {
    id: "faq-006",
    question: "如果发现侵权内容应该如何处理？",
    answer: "我们高度重视知识产权保护。如果您在平台上发现疑似侵权内容，可以通过「举报」功能或联系客服进行反馈。我们承诺在24小时内响应并启动调查流程。一经核实，将立即下架侵权内容并追究上传者责任。"
  }
];